import { render, staticRenderFns } from "./ProfileAcademicInfo.vue?vue&type=template&id=7218efa4&scoped=true&"
import script from "./ProfileAcademicInfo.vue?vue&type=script&lang=js&"
export * from "./ProfileAcademicInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProfileAcademicInfo.vue?vue&type=style&index=0&id=7218efa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7218efa4",
  null
  
)

export default component.exports